module.exports = __webpack_public_path__ + "img/Sudan.157df901.svg";